// Module Overview (cockpit) Page Permissions
//
// Ids assigned by the central permission registry for the keys registered by
// amer-laravel's 2026_08_10_120000_add_module_overview_permissions migration.

export const OVERVIEW_PROPERTIES_INDEX = 1455; // overview.properties
export const OVERVIEW_FINANCE_INDEX = 1456; // overview.finance
export const OVERVIEW_INVENTORY_INDEX = 1457; // overview.inventory
export const OVERVIEW_MAINTENANCE_INDEX = 1458; // overview.maintenance
export const OVERVIEW_CUSTOMERS_INDEX = 1459; // overview.customers
